import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { CommunityReplyListasyncReqPros, CommunityReplyListInitialState } from "../model/CommunityReplyListReducerType";
import CommonUtil from "../utils/CommonUtil";

const reducerId = "CommunityReplyListReducer/asyncReqCommunityReplyList";
const controllerMap = new Map();

const initialState: CommunityReplyListInitialState = {
    status: "",
    currPage: 1,
    n4ErrorCode: 0,
    strErrorMessage: "",
    n4CurrCount: 0,
    n4TotalCount: 0,
    n4TotalPage: 0,
    LIST: [],
    MORE_LIST: []
};

const slice = createSlice({
    name: "CommunityReplyListReducer",
    initialState,
    reducers: {
        setCurrPage: (state, action) => {
            state.currPage = action.payload;
        },
        addList: (state, action) => {
            if (action.payload.UCBC_REF_COMMENT_SEQ === action.payload.UCBC_COMMENT_SEQ) {
                state.MORE_LIST.push(action.payload);
            }
            else {
                let isRefAdd = false;
                let isRefEquals = false;
                let new_list: typeof state.MORE_LIST = [];
                state.MORE_LIST.forEach((item) => {
                        new_list.push(item);
                    if (item.UCBC_REF_COMMENT_SEQ === action.payload.UCBC_REF_COMMENT_SEQ) {
                        isRefEquals = true;
                    }
                    if (item.UCBC_REF_COMMENT_SEQ !== action.payload.UCBC_REF_COMMENT_SEQ && isRefEquals) {
                        new_list.pop();
                        new_list.push(action.payload);
                        new_list.push(item);
                        isRefAdd = true;
                        isRefEquals = false;
                    }
                });
                if (!isRefAdd) new_list.push(action.payload);
                state.MORE_LIST = new_list;
            }
        },
        removeItem: (state, action) => {
            state.MORE_LIST = state.MORE_LIST.filter((item) => item.UCBC_COMMENT_SEQ !== action.payload);
        }
    },
    extraReducers: (builder) => {
        builder.addCase(asyncReqCommunityReplyList.pending, (state) => {
            state.status = "LOADING";
        });
        builder.addCase(asyncReqCommunityReplyList.fulfilled, (state, action) => {
            state.status = "COMPLETE";
            state.n4ErrorCode = action.payload.n4ErrorCode;
            state.strErrorMessage = action.payload.strErrorMessage;
            state.n4CurrCount = action.payload.n4CurrCount;
            state.n4TotalCount = action.payload.n4TotalCount;
            state.n4TotalPage = action.payload.n4TotalPage;
            state.LIST = action.payload.LIST;

            if (state.MORE_LIST.length > 0) {
                // 게시물이 이동 된 경우, 더보기 목록 초기화
                if (state.MORE_LIST[0].UCBC_BOARD_SEQ !== CommonUtil.getQuerystring("board_seq", "")) state.MORE_LIST = [];
            }

            // 더보기 목록 누적
            const prev = [...state.MORE_LIST]; // 기존 배열 복사 (선택적, 불변성 유지용)
            const prevIds = new Set(prev.map(item => String(item.UCBC_COMMENT_SEQ)));
            const newItems = state.LIST.filter(
                item => !prevIds.has(item.UCBC_COMMENT_SEQ)
            );
            state.MORE_LIST = [...prev, ...newItems];
        });
        builder.addCase(asyncReqCommunityReplyList.rejected, (state, action) => {
            if (action.payload?.aborted) return; // 'AbortError'로 인한 취소라면 상태 변경하지 않음
            state.status = "FAIL";
        });
    }
});

type RejectPayload = { aborted: boolean; message?: string };

export const asyncReqCommunityReplyList = createAsyncThunk<
        any, // 성공 시 반환 타입 (API 응답 타입)
        CommunityReplyListasyncReqPros, // thunk 파라미터 타입
        {
            rejectValue: RejectPayload; // ❗ rejectWithValue 타입 명시
        }
    >(
    reducerId,
    async ({ page_size, curr_page, board_seq }: CommunityReplyListasyncReqPros, thunkAPI) => {
        // 이전 요청이 있으면 취소
        const prevController = controllerMap.get(reducerId);
        if (prevController) prevController.abort();

        // 새 요청용 controller 생성
        const controller = new AbortController();
        controllerMap.set(reducerId, controller);

        try {
            const res = await fetch(
                `${process.env.REACT_APP_API_DOMAIN}/ApiReact/CommunityReplyList.aspx?page_size=${page_size}&curr_page=${curr_page}&board_seq=${encodeURIComponent(board_seq)}`,
                {
                    signal: controller.signal,
                }
            );
            const data = await res.json();
            return data;
        }
        catch (error: any) {
            // ❗ AbortError인 경우는 구분해서 처리
            if (error.name === "AbortError") {
                return thunkAPI.rejectWithValue({ aborted: true });
            }
            return thunkAPI.rejectWithValue({ aborted: false, message: error.message });
        }
    }
);

export const CommunityReplyListActions = slice.actions;
export default slice.reducer;